import LinkInline from "@Front/Components/Layouts/Legal/LegalInformations/elements/LinkInline";
import type { DeploymentLineLegalNotice } from "le-coffre-resources/dist/deploymentLineLegalPublisher";

import { LegalNoticeLine, LegalNoticeMailLink, LegalNoticeSectionTitle } from "./LegalNoticePrimitives";

type LegalNoticeEditorProps = {
	notice: DeploymentLineLegalNotice;
};

export function LegalNoticeEditor(props: LegalNoticeEditorProps): React.JSX.Element {
	const { notice } = props;
	return (
		<>
			<LegalNoticeSectionTitle>02 Éditeur du site</LegalNoticeSectionTitle>
			<LegalNoticeLine>{notice.editorName}</LegalNoticeLine>
			<LegalNoticeLine>Responsable : {notice.editorResponsibleName}</LegalNoticeLine>
			<LegalNoticeLine>Forme juridique : {notice.editorLegalForm}</LegalNoticeLine>
			<LegalNoticeLine>Adresse : {notice.editorAddress}</LegalNoticeLine>
			<LegalNoticeLine>SIRET : {notice.editorSiret}</LegalNoticeLine>
			<LegalNoticeLine>TVA : {notice.editorVatNote}</LegalNoticeLine>
			<LegalNoticeLine>Activité : {notice.editorActivity}</LegalNoticeLine>
			<LegalNoticeLine>
				Site web : <LinkInline text={notice.editorWebsiteLabel} href={notice.editorWebsiteHref} />
			</LegalNoticeLine>
			<LegalNoticeLine>
				Contact : <LegalNoticeMailLink email={notice.editorContactEmail} />
			</LegalNoticeLine>
		</>
	);
}
